export const environment = {
  production: false,
  env: 'staging',
  undergoing_deployment: false,

  icrpURL: 'https://www.cac.oasisproducts.ng',

  apiBaseURL: 'https://bor.oasisproducts.ng/api',
  authBaseURL: '/auth_app',
  fileApiUrl: '/file_server_service/edmsapp',

  localStoreEncryptionKey: 'MkYgh3eKqFWDRM3zG63TT0EN6rKeYRaz-JUPF2FzhR0xHzFjXuXeAdDoIuUylvkid_6Gy7xv1tmdoSot',
  recaptchaSiteKey: '6LftujkrAAAAADF3IZ59XeuGAPzuiPrjXkHDe5oN',

  get baseURL(): string {
    if (typeof window !== 'undefined') {
      const parsedUrl = new URL(window.location.href);
      return parsedUrl.origin;
    }

    return '';
  },
};
